<template>
  <div class="mobile-page">
    <div v-if="status===1">
      <div class="mobile-header">
        <div class="mobile-title">{{isGaosan ? '2019高考真题在线估分' : '2019高考真题挑战赛'}}</div>
        <div class="estimate-num">
          <span v-for="n in numbers">{{n}}</span>
        </div>
        <div class="mobile-desc">{{isGaosan ? '在线估分考生人数' : '在线挑战人数'}}</div>
        <div class="waves"></div>
      </div>
      <div class="mobile-content">
        <div v-if="estimateStat">
          <div class="quiz-info">{{estimateStat.quiz.name}}
          {{estimateStat.major.id === 0 ? '' : `(${estimateStat.major.name})`}}</div>
          <div class="change-quiz" @click="changeQuiz('change')">更换考试省份</div>
          </div>
          <div v-else class="change-quiz choose" @click="changeQuiz('init')">请选择考试省份</div>
        <div class="hr"></div>
        <div class="quiz-num">{{ estimateStat ? estimateStat.quizUserCount : 0 }}</div>
        <div class="quiz-tip">{{ isGaosan ? '参与估分人数' : '参与挑战人数' }}</div>
        <div class="hr"></div>
        <div class="quiz-num">{{ estimateStat ? estimateStat.topUserCount : 0 }}</div>
        <div class="quiz-tip">高于 {{ estimateStat ? estimateStat.threshold : 0}} 分人数</div>

        <div class="footer-btn">
          <button :class="{disabled: !estimateStat}" @click="startEstimate">{{isGaosan ? '开始估分' : '开始挑战'}}</button>
        </div>
      </div>
      <div class="copyright" @click="gotoUrl()">北京贞观雨科技有限公司版权所有 关于我们</div>
    </div>
    <div v-else-if="status===2">
      <div class="select-content">
        <div class="select-title">文理分科</div>
        <div class="select-list">
          <div class="cell major-cell"
            :class="{active: m.id === majorId}"
            v-for="(m,index) in majors"
            :key="index"
            @click="majorId = m.id">{{m.name}}</div>
        </div>
        <div class="select-title">选择省份</div>
        <div class="select-list">
          <city-cell
            v-for="quiz in quizzes"
            :key="quiz.id"
            @select="selectSubject(quiz)"
            :quiz="quiz"
            :majorId="majorId"
            :quizId="quizId"></city-cell>
        </div>
      </div>
      <div class="confirm-btn">
        <button :class="{disabled: !confirm }" @click="confirmSelect">确定</button>
      </div>
    </div>
    <div v-else class="personal">
      <personal v-if="status==3" :majorId="majorId" :quizId="quizId"></personal>
    </div>
  </div>
</template>

<script>
import Personal from './Personal'
import CityCell from './CityCell'
import apiService from '../services/api'
import ua from '../utils/ua'
// import Frog from '../../node_modules/@yuanfudao/frog'
import queryUtil from '../utils/query'
import WebView from '@solar/common-webview'

const query = queryUtil.parse()
const shareMap = {
  qq: '/click/evaluate2019Homepage/shareToQQ',
  qzone: '/click/evaluate2019Homepage/shareToQzone',
  wechat: '/click/evaluate2019Homepage/shareToWeixin',
  moments: '/click/evaluate2019Homepage/shareToMoments',
  weibo: '/click/evaluate2019Homepage/shareToWeibo'
}

export default {
  name: 'mobile-page',
  components: {
    Personal, CityCell
  },
  data () {
    return {
      majors: [{
        id: 1,
        name: '文科'
      }, {
        id: 2,
        name: '理科'
      }, {
        id: 0,
        name: '文理不分科'
      }],
      quizzes: [],
      majorId: null,
      quizId: null,
      estimateStat: null,
      numbers: [0, 0, 0, 0, 0, 0],
      isLogin: false,
      // from: query.from,
      keyfrom: query.keyfrom,
      appId: ua.getAppId(),
      isGaosan: Number(query.isGaosan),
      type: Number(query.isGaosan) ? 2 : 1,
      wenanId: 255
    }
  },

  computed: {
    status () {
      return Number(this.$route.params.status) || 1
    },

    confirm () {
      const { majorId, quizId } = this
      if (majorId === 0) {
        return quizId === 817 || quizId === 855 || quizId === 841
      } else if (majorId === 1 || majorId === 2) {
        return quizId > 0 && quizId !== 817 && quizId !== 855 && quizId !== 841
      }
      return false
    }
  },

  watch: {
    status () {
      this.onStatusChange()
    }
  },

  created () {
    this.onStatusChange()
    window.document.title = this.isGaosan ? '2019高考真题在线估分' : '2019高考真题挑战赛'
    if (ua.isYuanSouTi()) {
      apiService.getSolarUser().then(res => {
        if (!res.body.trial) {
          this.isLogin = true
          window.ytkUserId = res.body.ytkUserId
          window.solarUserId = res.body.userId
        }
        if (this.status === 2) {
          this.changeQuiz()
        }
      }).catch(() => {
        if (this.status === 2) {
          this.changeQuiz()
        }
      })
    } else {
      apiService.getUser().then(res => {
        if (!res.body.trial) {
          this.isLogin = true
          window.ytkUserId = res.body.id
        }
        if (this.status === 2) {
          this.changeQuiz()
        }
      }).catch(() => {
        if (this.status === 2) {
          this.changeQuiz()
        }
      })
    }
    apiService.getEstimateStat(815, 2).then(res => {
      const userCount = '' + res.body.userCount
      const count = '0'.repeat(6 - userCount.length) + userCount
      this.numbers = count.split('')
    })
    if (this.status === 1) {
      this.$addFrog('/event/evaluate2019Homepage/enter', {type: this.type})
    }
  },

  methods: {
    startEstimate () {
      if (this.estimateStat) {
        this.$addFrog('/click/evaluate2019Homepage/start', { type: this.type, courseid: this.estimateStat.major.id, provinceid: this.estimateStat.quiz.id })
        this.changeStatus(3)
      }
    },
    selectSubject (quiz) {
      if ((this.majorId === 0 && quiz.id !== 817 && quiz.id !== 855 && quiz.id !== 841) ||
        ((this.majorId === 1 || this.majorId === 2) &&
        (quiz.id === 817 || quiz.id === 855 || quiz.id === 841))) {
        return false
      }
      this.quizId = quiz.id
    },
    confirmSelect () {
      if (this.confirm) {
        apiService.setUserInfo(this.quizId, this.majorId).then(res => {
          this.getEstimateStat()
          this.changeStatus(1, true)
        })
      }
    },
    getEstimateStat () {
      apiService.getEstimateStat(this.quizId, this.majorId).then(res => {
        this.estimateStat = res.body
        this.majorId = this.estimateStat.major.id
        this.quizId = this.estimateStat.quiz.id
        const userCount = '' + this.estimateStat.userCount
        const count = '0'.repeat(6 - userCount.length) + userCount
        this.numbers = count.split('')
      })
    },
    changeStatus (status, replace) {
      if (this.status === status) {
        return
      }

      if (status !== 1) {
        this.checkLogin(() => {
          this.handleStatusChange(status, replace)
        })
      } else {
        this.handleStatusChange(status, replace)
      }
    },
    handleStatusChange (status, replace) {
      this.status = status
      if (replace) {
        this.$router.go(-1)
      } else {
        this.$router.push({name: 'main', params: {status}})
      }
    },
    changeQuiz (param) {
      const { type } = this
      if (param === 'init') {
        this.$addFrog('/click/evaluate2019Homepage/choose', { type: type })
      } else {
        this.$addFrog('/click/evaluate2019Homepage/change', { type: type })
      }
      this.checkLogin(() => {
        apiService.getQuizzes().then(res => {
          this.quizzes = res.body
          this.changeStatus(2)
        }, err => {
          if (err.status === 401) {
            this.login()
          }
        })
      })
    },
    shareCallback (err, platform) {
      const { type } = this
      console.log(err, platform)
      this.$addFrog(shareMap[platform], { type: type })
    },
    onShare () {
      const { type } = this
      this.$addFrog('/click/evaluate2019Homepage/share', { type: type })
      WebView.showShareWindow({
        shareInfoUrl: `${location.protocol}//${location.host}/wenan/api/groups/${this.wenanId}`,
        trigger: this.shareCallback
      })
    },
    onStatusChange () {
      if (this.status === 1) {
        // NOTE: crm中配置分享文案
        if (this.isGaosan) {
          WebView.setTitle('2019高考真题在线估分')
          this.wenanId = /\.biz/.test(location.host) ? 255 : 1477
        } else {
          WebView.setTitle('2019高考真题挑战赛')
          this.wenanId = /\.biz/.test(location.host) ? 257 : 1475
        }
        WebView.setRightButton({
          hidden: false,
          text: '分享',
          trigger: this.onShare,
          image: 'iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAAAXNSR0IArs4c6QAAAQdJREFUaAXt1EEOgjAQhWFb9y45gpGz6Dk8B4fSW7hyA4lX4AzgTOIQjA5N04QF+UlIy3QeaT8Nux0XAggggAACCCCAAAIIIIAAAggggAACCCCAwKYEQu5p6ro+j+PYSO4kdxdCaNq2vafes3bO9pN1QN3kMAw3C9sYY7wsHXLtnO1Lxzh/SM0/v9xPm1e3Rm/dq5fmLK9j1gGlX/+W/y6vbr3eulcvzVk++4DdlPyeeHXr8ta9emnO8nkH1A/KlJxNvLq1eOtevTRneR3384fUvO/7V1VVD+k7yuYOcj/lA3Nd+sDoO9fOpc7BOgIIIIAAAggggAACCCCAAAIIIIAAAgggsGWBN7tQbSsQFGljAAAAAElFTkSuQmCC'
        })
      } else {
        // window.YTK_API.setRightButton({ hidden: true })
        // window.YTK_API.setShareButton({ hidden: true })
      }
    },

    checkLogin (callback) {
      if (this.isLogin) {
        callback()
      } else {
        apiService.getUser().then(res => {
          window.ytkUserId = res.body.id
          if (!res.body.trial) {
            this.isLogin = true
            callback()
          } else {
            this.login()
          }
        })
        .catch(() => {
          this.login()
        })
      }
    },

    login () {
      // 未登录
      if (/yuanfudao|yuantiku|yuansouti/i.test(navigator.userAgent)) {
        window.YTK_API.login({
          callback: function () {
            window.location.reload() // 题库回调
          }
        }, () => {
          window.location.reload() // 搜题回调
        })
      } else {
        window.location.href = '/h5/ape-web-login/?redirect=' + encodeURIComponent(window.location.href)
      }
    },

    gotoUrl () {
      window.location.href = 'https://ytk.yuanfudao.com/ape-web-page/3343'
    }
  }
}
</script>

<style scoped>
.mobile-page {
  height: 100vh;
}
.mobile-header {
  position: relative;
  width: 100%;
  height: 238px;
  text-align: center;
  background: #0097ff;
  color: #FFF;
}
.mobile-title {
  padding-top: 20px;
  font-size: 18px;
}
.estimate-num {
  margin-top: 30px;
}
.estimate-num {
  font-size: 30px;
}
.estimate-num span {
  display: inline-block;
  margin: 0 3px;
  width: 39px;
  height: 48px;
  line-height: 48px;
  background: url('//gallery.fbcontent.cn/api/ape/images/15c0a311e3433e6.png') no-repeat;
  background-size: contain;
  text-align: center;
}
@media only screen and (max-width: 330px) {
  .estimate-num span {
    height: 42px;
    width: 35px;
    line-height: 42px;
    font-size: 28px;
  }
}
.estimate-num span:nth-of-type(3) {
  margin-right: 10px;
}
.mobile-desc {
  margin-top: 30px;
  font-size: 14px;
}
.waves {
  position: absolute;
  bottom: -1px;
  width: 100%;
  height: 41px;
  background: url('//gallery.fbcontent.cn/api/ape/images/15c442b80d7c500.png') no-repeat;
  background-size: cover;
}

.mobile-content {
  padding: 15px;
  text-align: center;
}
.quiz-info {
  font-size: 18px;
  color: #666;
  text-align: center;
}
.change-quiz {
  margin-top: 13px;
  font-size: 12px;
  color: #0099FF;
  text-align: center;
}
.choose {
  font-size: 20px;
}
.hr {
  margin: 14px auto;
  border-top: 1px solid #CCC;
  width: 20px;
  color: #CCC;
}
.quiz-num {
  font-size: 18px;
  color: #666;
}
.quiz-tip {
  color: #999;
  font-size: 12px;
}
.footer-btn {
  margin-top: 32px;
  color: #FFF;
}

.confirm-btn {
  position: fixed;
  bottom: 0;
  padding: 10px 15px;
  border-top: 1px solid #e7e7e7;
  width: 100%;
  background: #FFF;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.footer-btn button, .confirm-btn button {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  color: #FFF;
  background: #0099FF;
}

.footer-btn button.disabled {
  background: #ABABAB;
  color: #FFF;
}

.confirm-btn button.disabled {
  background: #DCDCDC;
  color: #FFF;
}
.select-content {
  padding: 15px 15px 75px;
  width: 100%;
  box-sizing: border-box;
}
.select-title {
  padding: 15px 0;
  font-size: 15px;
  color: #666;
  clear: both;
}
.select-list {
  width: 100%;
}
.select-list .cell {
  display: inline-block;
  margin-bottom: 10px;
  height: 45px;
  width: 30%;
  font-size: 12px;
  color: #666;
  background: #f6f6f6;
  text-align: center;
  border-radius: 5px;
}
.major-cell {
  line-height: 45px;
}
.cell.active {
  background: #0097FF;
  color: #FFF;
}
.select-list .cell:nth-of-type(3n+2) {
  margin-left: 5%;
  margin-right: 5%;
}
.personal {
  height: 100%;
  background: #F2F5F5;
}
.copyright {
  margin: 10px 0;
  text-align: center;
  font-size: 12px;
  color: #979797;
}
</style>



// WEBPACK FOOTER //
// MobilePage.vue?1d3ec88a